export default {"src":"/_next/static/media/volley_ball.6fcc241f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};